export const initLazyZoom = (graph: any) => {
  // Accumulates the zoom factor while the rendering is taking place
  // so that not the complete sequence of zoom steps must be painted
  graph.updateZoomTimeout = null;
  graph.cumulativeZoomFactor = 1;
  let p1;
  let p2;
  graph.lazyZoomDelay = 0;
  graph.lazyZoom = evt => {
    const { scale } = graph.view;
    if (graph.updateZoomTimeout != null) {
      window.clearTimeout(graph.updateZoomTimeout);
    }
    // Switches to 1% zoom steps below 15%
    // Lower bound depends on rounding below
    if (evt.deltaY > 1) {
      if (scale > 10) {
        return;
      }
      if (graph.view.scale * graph.cumulativeZoomFactor < 0.15) {
        graph.cumulativeZoomFactor = (graph.view.scale + 0.01) / graph.view.scale;
      } else {
        // Uses to 5% zoom steps for better grid rendering in webkit
        // and to avoid rounding errors for zoom steps
        graph.cumulativeZoomFactor *= graph.zoomFactor;
        graph.cumulativeZoomFactor =
          Math.round(graph.view.scale * graph.cumulativeZoomFactor * 20) / 20 / graph.view.scale;
      }
    } else {
      if (scale < 0.2) {
        return;
      }
      // eslint-disable-next-line no-lonely-if
      if (graph.view.scale * graph.cumulativeZoomFactor <= 0.15) {
        graph.cumulativeZoomFactor = (graph.view.scale - 0.01) / graph.view.scale;
      } else {
        // Uses to 5% zoom steps for better grid rendering in webkit
        // and to avoid rounding errors for zoom steps
        graph.cumulativeZoomFactor /= graph.zoomFactor;
        graph.cumulativeZoomFactor =
          Math.round(graph.view.scale * graph.cumulativeZoomFactor * 20) / 20 / graph.view.scale;
      }
    }

    graph.cumulativeZoomFactor = Math.max(
      0.01,
      Math.min(graph.view.scale * graph.cumulativeZoomFactor, 160) / graph.view.scale
    );

    graph.updateZoomTimeout = window.setTimeout(() => {
      const { gridEnabled } = graph;
      // disable snapping
      graph.gridEnabled = false;
      if (graph.cumulativeZoomFactor >= 0.5 && evt.shiftKey) {
        p1 = graph.getPointForEvent(evt, false);
        graph.zoom(graph.cumulativeZoomFactor);
        p2 = graph.getPointForEvent(evt, false);

        if (p1 && p2) {
          graph.view.setTranslate(graph.view.translate.x + (p2.x - p1.x), graph.view.translate.y + (p2.y - p1.y));
        }
      }
      graph.gridEnabled = gridEnabled;
      graph.cumulativeZoomFactor = 1;
      graph.updateZoomTimeout = null;
    }, graph.lazyZoomDelay);
  };
};
